"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHandleBiddingTable = exports.BidTableAction = void 0;
var react_1 = require("react");
var lodash_1 = require("lodash");
var networking_1 = require("../networking");
var types_1 = require("../types");
var BidTableAction;
(function (BidTableAction) {
    BidTableAction["Clear"] = "clear";
    BidTableAction["Replace"] = "replace";
    BidTableAction["Upsert"] = "upsert";
    BidTableAction["RemoveBid"] = "removeBid";
    BidTableAction["UpdateBidAmount"] = "updateBidAmount";
})(BidTableAction || (exports.BidTableAction = BidTableAction = {}));
var defaultBidder = "None";
var defaultTopBidderState = { amount: 0, bidder: defaultBidder };
var useHandleBiddingTable = function (_a) {
    var messageService = _a.messageService, auctionId = _a.auctionId, lotId = _a.lotId, currentUserProfileId = _a.currentUserProfileId;
    var subscriptionRef = (0, react_1.useRef)();
    var _b = (0, react_1.useState)(defaultTopBidderState), topBidder = _b[0], setTopBidder = _b[1];
    var _c = (0, react_1.useReducer)(function (state, action) {
        switch (action.type) {
            case BidTableAction.Clear:
                return [];
            case BidTableAction.Replace:
                // when screen is opened.
                return (0, lodash_1.sortBy)(action.data, ["amount"]).reverse().slice(0, 15);
            case BidTableAction.Upsert:
                // when a bid is created and added to the table in real time.
                var newState = __spreadArray([], state, true);
                var _a = action.data, incomingAmount = _a.amount, incomingPaddleNumber_1 = _a.paddleNumber;
                var incomingAmountAsNumber_1 = Number(incomingAmount);
                var indexMatchedEntry = newState.findIndex(function (_a) {
                    var amount = _a.amount, paddleNumber = _a.paddleNumber;
                    return amount === incomingAmountAsNumber_1 && paddleNumber === incomingPaddleNumber_1;
                });
                if (indexMatchedEntry !== -1) {
                    newState[indexMatchedEntry] = __assign(__assign({}, action.data), { amount: incomingAmountAsNumber_1 });
                }
                else {
                    newState.push(__assign(__assign({}, action.data), { amount: incomingAmountAsNumber_1 }));
                }
                return (0, lodash_1.sortBy)(newState, ["amount"]).reverse().slice(0, 15);
            case BidTableAction.RemoveBid:
                return state.filter(function (_a) {
                    var bidId = _a.bidId;
                    return bidId !== action.data.bidId;
                });
            case BidTableAction.UpdateBidAmount:
                return state.map(function (tableRow) {
                    if (tableRow.bidId === action.data.bidId) {
                        return __assign(__assign(__assign({}, tableRow), action.data), { amount: Number(action.data.amount) });
                    }
                    return tableRow;
                });
            default:
                return __spreadArray([], state, true);
        }
    }, []), tableRowData = _c[0], setTableRowData = _c[1];
    var _d = (0, networking_1.useRetrieveBiddingPageData)({
        auctionId: auctionId,
        lotId: lotId,
        profileId: currentUserProfileId,
    }, {
        refetchOnWindowFocus: false,
    }), remoteLotData = _d.data, refetchRemoteLotData = _d.refetch, restHandleLoadLotData = __rest(_d, ["data", "refetch"]);
    (0, react_1.useEffect)(function () {
        var _a;
        if (remoteLotData) {
            var bidsArr_1 = [];
            (_a = remoteLotData === null || remoteLotData === void 0 ? void 0 : remoteLotData.bids) === null || _a === void 0 ? void 0 : _a.map(function (bid) {
                if (!bidsArr_1.find(function (f) { var _a; return f.amount === bid.amount && f.paddleNumber === ((_a = bid.registeredProfile) === null || _a === void 0 ? void 0 : _a.paddleNumber); })) {
                    bidsArr_1.push({
                        bidId: bid.id,
                        amount: bid.amount,
                        paddleNumber: bid.registeredProfile.paddleNumber,
                    });
                }
            });
            setTableRowData({ type: BidTableAction.Replace, data: bidsArr_1 });
        }
    }, [remoteLotData]);
    (0, react_1.useEffect)(function () {
        var _a;
        var _b = (_a = tableRowData[0]) !== null && _a !== void 0 ? _a : {}, amount = _b.amount, bidder = _b.paddleNumber;
        if (amount && bidder) {
            setTopBidder({
                amount: amount,
                bidder: bidder,
            });
        }
        else {
            setTopBidder(defaultTopBidderState);
        }
    }, [tableRowData]);
    (0, react_1.useEffect)(function () {
        if (subscriptionRef.current)
            subscriptionRef.current.unsubscribe();
        subscriptionRef.current = messageService.onMessage().subscribe(function (message) {
            if (message) {
                var payload = message.text;
                var _a = payload.data, messageSubject = _a.messageSubject, entityId = _a.entityId, // lotId - lock/release of this lot has taken place
                notificationLotId = _a.lotId, notificationAuctionId = _a.auctionId, amount = _a.amount, notificationTopBidder = _a.topBidder, bidAmount = _a.bidAmount, // bid amount updated for specific lot,
                deleted = _a.deleted, // bid deleted from specific lot
                bidId = _a.bidId;
                var isNotificationThisLot = entityId === lotId || notificationLotId === lotId;
                var isNotificationThisAuction = notificationAuctionId === auctionId;
                var mayAddBid = amount !== undefined && amount !== "" && notificationTopBidder !== undefined && notificationTopBidder !== "";
                try {
                    if (isNotificationThisLot) {
                        if (messageSubject === types_1.MessageSubject.BidUpdated) {
                            if (deleted) {
                                setTableRowData({
                                    type: BidTableAction.RemoveBid,
                                    data: {
                                        bidId: bidId,
                                    },
                                });
                            }
                            if (bidAmount) {
                                setTableRowData({
                                    type: BidTableAction.UpdateBidAmount,
                                    data: {
                                        bidId: bidId,
                                        amount: bidAmount,
                                    },
                                });
                            }
                        }
                    }
                    if (isNotificationThisAuction && isNotificationThisLot) {
                        if (messageSubject === types_1.MessageSubject.CreateBid) {
                            if (mayAddBid) {
                                setTableRowData({
                                    type: BidTableAction.Upsert,
                                    data: {
                                        bidId: bidId,
                                        amount: amount,
                                        paddleNumber: notificationTopBidder,
                                    },
                                });
                            }
                        }
                    }
                }
                catch (e) {
                    //TODO: may handle this error in the future
                }
            }
        });
        return function cleanup() {
            subscriptionRef.current.unsubscribe();
            subscriptionRef.current = undefined;
        };
    }, [auctionId, lotId, messageService]);
    return __assign({ tableRowData: tableRowData, setTableRowData: setTableRowData, topBidder: topBidder, remoteLotData: remoteLotData, refetchRemoteLotData: refetchRemoteLotData }, restHandleLoadLotData);
};
exports.useHandleBiddingTable = useHandleBiddingTable;
